import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

interface Entry {
  rank: number;
  displayName: string;
  score: number;
  dezoomsUsed: number;
  isMe: boolean;
}

export function LeaderboardPage() {
  const { user } = useAuth();
  const [entries, setEntries] = useState<Entry[]>([]);
  const [myRank, setMyRank] = useState<number | null>(null);
  const [puzzleNumber, setPuzzleNumber] = useState(0);

  useEffect(() => {
    api<{ entries: Entry[]; myRank: number | null; puzzleNumber: number }>('/leaderboard/today')
      .then((data) => {
        setEntries(data.entries);
        setMyRank(data.myRank);
        setPuzzleNumber(data.puzzleNumber);
      })
      .catch(() => {});
  }, []);

  return (
    <main className="page leaderboard">
      <h1>{t('leaderboard.title')}</h1>
      <p className="sub">Énigme #{puzzleNumber}</p>
      {user && myRank != null && <p className="my-rank">Ton rang : #{myRank}</p>}
      <ol className="lb-list">
        {entries.map((e) => (
          <li key={e.rank} className={e.isMe ? 'me' : ''}>
            <span className="rank">#{e.rank}</span>
            <span className="name">{e.displayName}</span>
            <span className="pts">{e.score}</span>
          </li>
        ))}
      </ol>
      {!entries.length && <p className="muted">Aucun score pour l'instant.</p>}
      <Link to="/play" className="btn primary">Jouer</Link>
    </main>
  );
}
